import { MockedVdd } from '@vi-iot/client/apis/remote-diagnostics/mocked-vdds/MockedVdd.model';
import {
  DiagnosticsStackGenericResponse,
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddRootMetadataResponse,
  RemoteDiagnosticsVddRootStructureResponse,
} from '@vi-iot/client';
import { VddNames } from '../../../../../app/+installations/diagnostics-overlay/tabs-content/extended-parameters/diagnostics-constants';

export class GatewayEthernetIp implements MockedVdd {
  readSingleSync(logicalLink?: string): RemoteDiagnosticsSuccessResponseData {
    return {
      RES: ' 62 06 A0 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00',
      request_parameter_name: 'PA_DataIdent',
      service: 'DS_ReadDataByIdent',
      ecu: logicalLink ?? 'LL_0024_EMCU_CAN71',
      requestDate: new Date().toISOString(),
      ecuvariant: logicalLink ?? 'LL_0024_EMCU_CAN71',
      request_parameter_value: VddNames.GatewayEthernetIp,
      securitystatus: '',
      type: 'ReadVddDataByVdd',
      structure: [
        {
          semantic: 'SERVICE-ID',
          path: 'PA_ServiID',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_ServiID',
          value: '98',
        },
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'GatewayEthernetIp',
        },
        {
          semantic: '',
          path: 'PA_DataRecor',
          translationid: '',
          dopname: '2 Byte Table VDD Greenbook',
          name: 'PA_DataRecor',
          structure: [
            {
              semantic: 'VALUE',
              path: 'PA_DataRecor/PA_GatewIpAddre',
              translationid: 'TI_GatewayIpAddress',
              dopname: '4 Byte Structure IpAddress',
              name: 'PA_GatewIpAddre',
              structure: [
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpAddre/PA_IP1',
                  unit: '',
                  translationid: 'TI_IP_1',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP1',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpAddre/PA_IP2',
                  unit: '',
                  translationid: 'TI_IP_2',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP2',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpAddre/PA_IP3',
                  unit: '',
                  translationid: 'TI_IP_3',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP3',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpAddre/PA_IP4',
                  unit: '',
                  translationid: 'TI_IP_4',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP4',
                  value: '0',
                },
              ],
            },
            {
              semantic: 'VALUE',
              path: 'PA_DataRecor/PA_GatewIpMask',
              translationid: 'TI_GatewayIpMask',
              dopname: '4 Byte Structure IpAddress',
              name: 'PA_GatewIpMask',
              structure: [
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpMask/PA_IP1',
                  unit: '',
                  translationid: 'TI_IP_1',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP1',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpMask/PA_IP2',
                  unit: '',
                  translationid: 'TI_IP_2',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP2',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpMask/PA_IP3',
                  unit: '',
                  translationid: 'TI_IP_3',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP3',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpMask/PA_IP4',
                  unit: '',
                  translationid: 'TI_IP_4',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP4',
                  value: '0',
                },
              ],
            },
            {
              semantic: 'VALUE',
              path: 'PA_DataRecor/PA_GatewIpGatew',
              translationid: 'TI_GatewayIpGateway',
              dopname: '4 Byte Structure IpAddress',
              name: 'PA_GatewIpGatew',
              structure: [
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpGatew/PA_IP1',
                  unit: '',
                  translationid: 'TI_IP_1',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP1',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpGatew/PA_IP2',
                  unit: '',
                  translationid: 'TI_IP_2',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP2',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpGatew/PA_IP3',
                  unit: '',
                  translationid: 'TI_IP_3',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP3',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpGatew/PA_IP4',
                  unit: '',
                  translationid: 'TI_IP_4',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP4',
                  value: '0',
                },
              ],
            },
            {
              semantic: 'VALUE',
              path: 'PA_DataRecor/PA_GatewIpDnsOne',
              translationid: 'TI_GatewayIpDnsOne',
              dopname: '4 Byte Structure IpAddress',
              name: 'PA_GatewIpDnsOne',
              structure: [
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpDnsOne/PA_IP1',
                  unit: '',
                  translationid: 'TI_IP_1',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP1',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpDnsOne/PA_IP2',
                  unit: '',
                  translationid: 'TI_IP_2',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP2',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpDnsOne/PA_IP3',
                  unit: '',
                  translationid: 'TI_IP_3',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP3',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpDnsOne/PA_IP4',
                  unit: '',
                  translationid: 'TI_IP_4',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP4',
                  value: '0',
                },
              ],
            },
            {
              semantic: 'VALUE',
              path: 'PA_DataRecor/PA_GatewIpDnsTwo',
              translationid: 'TI_GatewayIpDnsTwo',
              dopname: '4 Byte Structure IpAddress',
              name: 'PA_GatewIpDnsTwo',
              structure: [
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpDnsTwo/PA_IP1',
                  unit: '',
                  translationid: 'TI_IP_1',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP1',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpDnsTwo/PA_IP2',
                  unit: '',
                  translationid: 'TI_IP_2',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP2',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpDnsTwo/PA_IP3',
                  unit: '',
                  translationid: 'TI_IP_3',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP3',
                  value: '0',
                },
                {
                  semantic: 'IP',
                  path: 'PA_DataRecor/PA_GatewIpDnsTwo/PA_IP4',
                  unit: '',
                  translationid: 'TI_IP_4',
                  dopname: '1 Byte Identical uint8',
                  name: 'PA_IP4',
                  value: '0',
                },
              ],
            },
          ],
        },
        {
          semantic: '',
          path: 'PA_RecorDataIdentCheck',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_RecorDataIdentCheck',
          value: '',
        },
      ],
      REQ: ' 22 06 A0',
    };
  }
  metadata(): RemoteDiagnosticsVddRootMetadataResponse {
    return {
      request_parameter_name: 'PA_Param',
      service: 'DS_VDDMetaData',
      ecu: 'LL_0024_EMCU_CAN71',
      request_parameter_value: VddNames.GatewayEthernetIp,
      type: 'MetaDataByVddAndBaseVariant',
      structure: [
        {
          semantic: '',
          longname: 'Param',
          byteposition: '0',
          dopname: '2 Byte Text Table VDD-Greenbook',
          precision: '',
          byteLength: '16',
          type: 'eKEY',
          shortname: 'PA_Param',
          constraints: '',
          path: 'PA_Param',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Param',
          interval: '1696',
          value: 'GatewayEthernetIp',
        },
        {
          semantic: '',
          longname: 'Value',
          byteposition: '2',
          dopname: '2 Byte Table VDD MetaData',
          precision: '',
          byteLength: '-1',
          type: 'eTABLE',
          shortname: 'PA_Value',
          constraints: '',
          path: 'PA_Value',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Value',
          value: '',
        },
      ],
    };
  }
  structure(): DiagnosticsStackGenericResponse<RemoteDiagnosticsVddRootStructureResponse[]> {
    return {
      type: 'VddStructureByVddAndBaseVariant',
      structure: [
        {
          request_parameter_name: 'PA_Param',
          service: 'DS_VDDPAStruc',
          ecu: 'LL_0024_EMCU_CAN71',
          request_parameter_value: VddNames.GatewayEthernetIp,
          type: 'RequestStructureByParameterNameAndValue',
          structure: [
            {
              semantic: '',
              longname: 'Param',
              byteposition: '0',
              dopname: '2 Byte Text Table VDD-Greenbook',
              precision: '',
              byteLength: '16',
              type: 'eKEY',
              shortname: 'PA_Param',
              constraints: '',
              path: 'PA_Param',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Param',
              interval: '1696',
              value: 'GatewayEthernetIp',
            },
            {
              semantic: '',
              longname: 'Structure',
              byteposition: '2',
              dopname: '2 Byte Table VDD Greenbook',
              precision: '',
              byteLength: '-1',
              type: 'eTABLE',
              shortname: 'PA_Struc',
              constraints: '',
              structure: [
                {
                  semantic: 'VALUE',
                  longname: 'GatewayIpAddress',
                  byteposition: '0',
                  dopname: '4 Byte Structure IpAddress',
                  precision: '',
                  byteLength: '-1',
                  type: 'eSTRUCTURE',
                  shortname: 'PA_GatewIpAddre',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'IP',
                      longname: 'IP-1',
                      byteposition: '0',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP1',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpAddre/PA_IP1',
                      unit: '',
                      translationid: 'TI_IP_1',
                      bitposition: '0',
                      name: 'PA_IP1',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-2',
                      byteposition: '1',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP2',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpAddre/PA_IP2',
                      unit: '',
                      translationid: 'TI_IP_2',
                      bitposition: '0',
                      name: 'PA_IP2',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-3',
                      byteposition: '2',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP3',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpAddre/PA_IP3',
                      unit: '',
                      translationid: 'TI_IP_3',
                      bitposition: '0',
                      name: 'PA_IP3',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-4',
                      byteposition: '3',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP4',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpAddre/PA_IP4',
                      unit: '',
                      translationid: 'TI_IP_4',
                      bitposition: '0',
                      name: 'PA_IP4',
                      value: '0',
                    },
                  ],
                  path: 'PA_Struc/PA_GatewIpAddre',
                  unit: '',
                  translationid: 'TI_GatewayIpAddress',
                  bitposition: '0',
                  name: 'PA_GatewIpAddre',
                  value: '4',
                },
                {
                  semantic: 'VALUE',
                  longname: 'GatewayIpMask',
                  byteposition: '4',
                  dopname: '4 Byte Structure IpAddress',
                  precision: '',
                  byteLength: '-1',
                  type: 'eSTRUCTURE',
                  shortname: 'PA_GatewIpMask',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'IP',
                      longname: 'IP-1',
                      byteposition: '0',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP1',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpMask/PA_IP1',
                      unit: '',
                      translationid: 'TI_IP_1',
                      bitposition: '0',
                      name: 'PA_IP1',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-2',
                      byteposition: '1',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP2',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpMask/PA_IP2',
                      unit: '',
                      translationid: 'TI_IP_2',
                      bitposition: '0',
                      name: 'PA_IP2',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-3',
                      byteposition: '2',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP3',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpMask/PA_IP3',
                      unit: '',
                      translationid: 'TI_IP_3',
                      bitposition: '0',
                      name: 'PA_IP3',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-4',
                      byteposition: '3',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP4',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpMask/PA_IP4',
                      unit: '',
                      translationid: 'TI_IP_4',
                      bitposition: '0',
                      name: 'PA_IP4',
                      value: '0',
                    },
                  ],
                  path: 'PA_Struc/PA_GatewIpMask',
                  unit: '',
                  translationid: 'TI_GatewayIpMask',
                  bitposition: '0',
                  name: 'PA_GatewIpMask',
                  value: '4',
                },
                {
                  semantic: 'VALUE',
                  longname: 'GatewayIpGateway',
                  byteposition: '8',
                  dopname: '4 Byte Structure IpAddress',
                  precision: '',
                  byteLength: '-1',
                  type: 'eSTRUCTURE',
                  shortname: 'PA_GatewIpGatew',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'IP',
                      longname: 'IP-1',
                      byteposition: '0',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP1',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpGatew/PA_IP1',
                      unit: '',
                      translationid: 'TI_IP_1',
                      bitposition: '0',
                      name: 'PA_IP1',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-2',
                      byteposition: '1',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP2',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpGatew/PA_IP2',
                      unit: '',
                      translationid: 'TI_IP_2',
                      bitposition: '0',
                      name: 'PA_IP2',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-3',
                      byteposition: '2',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP3',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpGatew/PA_IP3',
                      unit: '',
                      translationid: 'TI_IP_3',
                      bitposition: '0',
                      name: 'PA_IP3',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-4',
                      byteposition: '3',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP4',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpGatew/PA_IP4',
                      unit: '',
                      translationid: 'TI_IP_4',
                      bitposition: '0',
                      name: 'PA_IP4',
                      value: '0',
                    },
                  ],
                  path: 'PA_Struc/PA_GatewIpGatew',
                  unit: '',
                  translationid: 'TI_GatewayIpGateway',
                  bitposition: '0',
                  name: 'PA_GatewIpGatew',
                  value: '4',
                },
                {
                  semantic: 'VALUE',
                  longname: 'GatewayIpDnsOne',
                  byteposition: '12',
                  dopname: '4 Byte Structure IpAddress',
                  precision: '',
                  byteLength: '-1',
                  type: 'eSTRUCTURE',
                  shortname: 'PA_GatewIpDnsOne',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'IP',
                      longname: 'IP-1',
                      byteposition: '0',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP1',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpDnsOne/PA_IP1',
                      unit: '',
                      translationid: 'TI_IP_1',
                      bitposition: '0',
                      name: 'PA_IP1',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-2',
                      byteposition: '1',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP2',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpDnsOne/PA_IP2',
                      unit: '',
                      translationid: 'TI_IP_2',
                      bitposition: '0',
                      name: 'PA_IP2',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-3',
                      byteposition: '2',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP3',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpDnsOne/PA_IP3',
                      unit: '',
                      translationid: 'TI_IP_3',
                      bitposition: '0',
                      name: 'PA_IP3',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-4',
                      byteposition: '3',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP4',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpDnsOne/PA_IP4',
                      unit: '',
                      translationid: 'TI_IP_4',
                      bitposition: '0',
                      name: 'PA_IP4',
                      value: '0',
                    },
                  ],
                  path: 'PA_Struc/PA_GatewIpDnsOne',
                  unit: '',
                  translationid: 'TI_GatewayIpDnsOne',
                  bitposition: '0',
                  name: 'PA_GatewIpDnsOne',
                  value: '4',
                },
                {
                  semantic: 'VALUE',
                  longname: 'GatewayIpDnsTwo',
                  byteposition: '16',
                  dopname: '4 Byte Structure IpAddress',
                  precision: '',
                  byteLength: '-1',
                  type: 'eSTRUCTURE',
                  shortname: 'PA_GatewIpDnsTwo',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'IP',
                      longname: 'IP-1',
                      byteposition: '0',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP1',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpDnsTwo/PA_IP1',
                      unit: '',
                      translationid: 'TI_IP_1',
                      bitposition: '0',
                      name: 'PA_IP1',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-2',
                      byteposition: '1',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP2',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpDnsTwo/PA_IP2',
                      unit: '',
                      translationid: 'TI_IP_2',
                      bitposition: '0',
                      name: 'PA_IP2',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-3',
                      byteposition: '2',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP3',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpDnsTwo/PA_IP3',
                      unit: '',
                      translationid: 'TI_IP_3',
                      bitposition: '0',
                      name: 'PA_IP3',
                      value: '0',
                    },
                    {
                      semantic: 'IP',
                      longname: 'IP-4',
                      byteposition: '3',
                      dopname: '1 Byte Identical uint8',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_IP4',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_GatewIpDnsTwo/PA_IP4',
                      unit: '',
                      translationid: 'TI_IP_4',
                      bitposition: '0',
                      name: 'PA_IP4',
                      value: '0',
                    },
                  ],
                  path: 'PA_Struc/PA_GatewIpDnsTwo',
                  unit: '',
                  translationid: 'TI_GatewayIpDnsTwo',
                  bitposition: '0',
                  name: 'PA_GatewIpDnsTwo',
                  value: '4',
                },
              ],
              path: 'PA_Struc',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Struc',
              value: '',
            },
          ],
        },
      ],
    };
  }
}
